import React from 'react';
import { routes } from 'constants/config';
import ImagePreview from 'components/shared/ImagePreview';

/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */

const TagRow = ({ tag, deleteTag, hasLearningLibrary, canCreateEditTags }) => {
  return (
    <div id={tag.id} className="DataTable-tr">
      <div className="DataTable-td DataTable-name">{tag.name}</div>

      {hasLearningLibrary && (
        <div className="DataTable-td">
          {t(`tags.learn.${tag.library_visibility}`)}
        </div>
      )}

      <div className="DataTable-td">
        {tag.image && <ImagePreview image={tag.image} />}
      </div>

      <div className="DataTable-td DataTable-description">
        {tag.description}
      </div>

      <div className="DataTable-td DataTable-actions">
        {canCreateEditTags && (
          <>
            <a href={routes.TAGS_EDIT(tag.id)}>{t('common.edit')}</a>
            {' | '}
            <a className="DataTable-action-link" onClick={deleteTag}>
              {t('common.delete')}
            </a>
          </>
        )}
      </div>
    </div>
  );
};

export default TagRow;
